/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_LIST_TABLE_ELEMENT',
  PUT: 'UPDATE_LIST_TABLE',
  UPDATE_ITEM: 'UPDATEI_ITEM_LIST_TABLE',
  UPDATE_ATRIBUTES: 'UPDATE_ATRIBUTES',
  UPDATE_ROW:'UPDATE_ROW',
  DELETE: 'DELETE_LIST_TABLE',
  RESET: 'RESET_LIST_TABLE',
  RELOAD: 'RELOAD_LIST_TABLE',
};

export const getDraftId = () => `listTable-${Date.now()}`;

export const listTableReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      const newValue = { ...state };
      let { payload } = action;
      if (!Array.isArray(payload)) {
        payload = [payload];
      }
      payload.forEach((payloadItem) => {
        newValue.total += 1;
        newValue.to += 1;
        newValue.data.push(payloadItem);
      });

      return newValue;
    case types.PUT:
      return state.map((child) => (child.id == action.payload.id ? action.payload : child));
    case types.UPDATE_ITEM:
      const newUpadateValues = { ...state };
      const newItem = { ...action.payload, newItem: true };
      if (newUpadateValues.currentPage == 1) {
        const itemIndex = newUpadateValues.data.findIndex((x) => x.id === newItem.id);
        if (itemIndex >= 0) {
          const newData = [...newUpadateValues.data];
          newData.splice(itemIndex, 1, newItem);
          newUpadateValues.data = newData;
        } else {
          newUpadateValues.data.unshift(newItem);
          newUpadateValues.total += 1;
          newUpadateValues.to += 1;
          if (newUpadateValues.total > newUpadateValues.perPage) {
            newUpadateValues.data.splice(newUpadateValues.data.length - 1, 1);
            newUpadateValues.nextPageUrl = `${newUpadateValues.path}?page=2`;
            newUpadateValues.to -= 1;
            newUpadateValues.lastPage = parseInt(newUpadateValues.total / newUpadateValues.perPage, 10) + 1;
          }
        }
      }

      return newUpadateValues;
    case types.DELETE:
      const newValues = { ...state };
      const index = newValues.data.indexOf(action.item);
      newValues.data.splice(index, 1);
      newValues.total -= 1;
      newValues.to -= 1;
      return newValues;
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    case types.UPDATE_ROW:
      const { row } = action.payload.items[0];
      const newS = { ...state };

      newS.data = state.data.map((value, i) => {
        let stateCopy = { ...value };
        if(action.payload.items[0].id==value.id){
          stateCopy=action.payload.items[0];
        }
        return stateCopy;
      });
      return newS;
    case types.UPDATE_ATRIBUTES:
      const { items } = action.payload;
      const { atributeToUpdate } = action.payload;
      const newState = { ...state };

      newState.data = state.data.map((value, i) => {
        const stateCopy = { ...value };
        atributeToUpdate.forEach((toUpdate) => {
          if (items[i]) {
            stateCopy[toUpdate] = items[i][toUpdate];
          }
        });
        return stateCopy;
      });

      return newState;
    default:
      return state;
  }
};
